import { render, staticRenderFns } from "./Accident.vue?vue&type=template&id=db9b8f30&scoped=true"
import script from "./Accident.vue?vue&type=script&lang=js"
export * from "./Accident.vue?vue&type=script&lang=js"
import style0 from "./Accident.vue?vue&type=style&index=0&id=db9b8f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9b8f30",
  null
  
)

export default component.exports